export default "__VITE_ASSET__4f4ae274__"